import { Breadcrumb } from '../../../Breadcrumbs'

import * as styles from './FileDirectoryBreadcrumb.module.css'

function FileDirectoryBreadcrumb(props) {
  return (
    <Breadcrumb
      {...props}
      clickable
      className={styles.FileDirectoryBreadcrumb}
    />
  )
}

export default FileDirectoryBreadcrumb
